import { Box, Button, Grid } from "@mui/material";
import { mainColor } from "../util/MuiTheme";

const ExternalNavigationTabs = () => {

    const tabData = [
        { label: "Eventi", color: " #fdd835", url: "https://santafara.org/eventi.html" },
        { label: "Catechismo", color: "#00b0f0", url: "https://santafara.org/catechismo.html" },
        { label: "Famiglie", color: "#d22d71", url: "https://santafara.org/famiglie.html" },
        { label: "Famiglia Francescana", color: "#ff9900", url: "https://santafara.org/famfrancescana.html" },
        { label: "Caritas", color: "#06ee04", url: "https://santafara.org/caritas.html" },
    ];

    return (<>
        <Box margin={2}>
            <Grid container columnSpacing={6}>
                {tabData.map(t => <Grid item xs={12} md={2.4}>
                    <Button
                        fullWidth
                        sx={{
                            minHeight: "100px",
                            backgroundColor: "white",
                            color: mainColor,
                            fontWeight: "bold",
                            boxShadow: "none",
                            fontSize: "20px",
                            borderBottom: "10px solid",
                            borderBottomColor: t.color,
                            borderRadius: 0,
                            '&:hover': {
                                backgroundColor: 'inherit',
                                boxShadow: 'none',
                            },
                        }}
                        href={t.url}
                    >
                        {t.label}
                    </Button>
                </Grid>)}
            </Grid>
        </Box>
    </>);
}

export default ExternalNavigationTabs;